import {Event} from "@app/core/tracking/domain/event";

/**
 * Event triggered when the app is opened with products in the cart.
 * This event is used to identify when users return to the app with items already in their cart,
 * enabling features like cart recovery prompts or personalized recommendations.
 */
export class AppOpenedWithProductsInCartEvent extends Event {
}